import React, { useEffect, useState, useRef } from "react";
import imgurl from './assests/images/imgurl';
import AddAPhotoOutlinedIcon from '@mui/icons-material/AddAPhotoOutlined';
import AddPhotoAlternateOutlinedIcon from '@mui/icons-material/AddPhotoAlternateOutlined';
import AutorenewOutlinedIcon from '@mui/icons-material/AutorenewOutlined';
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';
// import * as tf from '@tensorflow/tfjs';
// import * as posedetection from '@tensorflow-models/pose-detection';
import { setbackview, setfrontview, settopview, setleftview, setrightview, setactiveview } from './Reducers/reducer'
import { replace, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux'

const HeadCapture = () => {
    const [currentAngle, setCurrentAngle] = useState('front');
    const [capturedImages, setCapturedImages] = useState({});
    const [detector, setDetector] = useState(null);
    const angles = ['front', 'top', 'left', 'right', 'back'];
    const isCapturing = useRef(false); // Prevent multiple captures
    const navigate = useNavigate();
    const dispatch = useDispatch()

    const activeview = useSelector((state) => state.user.profile.activeview);


    useEffect(() => {
        // Ensure Cordova is available
        document.addEventListener("deviceready", startCamera, false);

        return () => {
            if (window.CameraPreview) {
                window.CameraPreview.stopCamera();
            }
        };
    }, []);

    // Load the pose detection model
    // useEffect(() => {
    //     const loadModel = async () => {
    //         await tf.ready(); // Ensure TensorFlow.js is ready
    //         const model = posedetection.SupportedModels.BlazePose;
    //         const detectorConfig = {
    //             runtime: 'tfjs', // Use TensorFlow.js runtime
    //             modelType: 'lite', // Lightweight model for mobile
    //         };
    //         const loadedDetector = await posedetection.createDetector(model, detectorConfig);
    //         setDetector(loadedDetector);
    //         console.log('Pose detector loaded');
    //     };
    //     loadModel();
    // }, []);

    const startCamera = () => {
        if (!window.CameraPreview) {
            console.error("CameraPreview plugin not available");
            return;
        }

        window.CameraPreview.startCamera(
            {
                x: 0,
                y: 0,
                width: window.screen.width,
                height: window.screen.height,
                camera: "front",
                tapPhoto: true,
                previewDrag: false,
                toBack: true, // Keep app UI on top
            },
            () => console.log("Camera started"),
            (error) => console.error("Camera error:", error)
        );
    };

    // Function to capture the image
    const captureImage = () => {
        window.CameraPreview.takePicture(
            { width: 500, height: 500, quality: 85 },
            (imageData) => {
                console.log(imageData);
                navigate(-1)
                if (activeview == "Front") {
                    dispatch(setfrontview(imageData))
                } else if (activeview == "Top") {
                    dispatch(settopview(imageData))
                } else if (activeview == "Left") {
                    dispatch(setleftview(imageData))
                } else if (activeview == "Right") {
                    dispatch(setrightview(imageData))
                } else if (activeview == "Back") {
                    dispatch(setbackview(imageData))
                }
            },
            (error) => console.error('Capture error:', error)
        );
    };



    return (

        <div className='camerapreview cameraprev'>

            <ArrowBackIosNewOutlinedIcon className='arrowback' onClick={() => navigate(-1)} />
            <div className='instructiontext'>
                {/* <img src={imgurl.previmg} alt="Selfie" /> */}
                <p>Please position your face inside the circle as per the view. Ensure your entire face is visible within the outline for the best results.</p>
            </div>
            <img src={imgurl.previmg} />

            <div className='camerapreviewicons'>
                <div>
                    <AddPhotoAlternateOutlinedIcon />
                </div>

                <div className='cameraoutline' onClick={() => captureImage()}>
                    <AddAPhotoOutlinedIcon />
                </div>

                <div>
                    <AutorenewOutlinedIcon />
                </div>
            </div>
        </div>
    );
};

const styles = {
    button: {
        position: "absolute",
        bottom: 20,
        left: "50%",
        transform: "translateX(-50%)",
        padding: 10,
        fontSize: 18,
        backgroundColor: "blue",
        color: "white",
        border: "none",
        borderRadius: 5,
    },
};

export default HeadCapture;
